import React, { useEffect, useState } from "react";

import {
  CRow,
  CCol,
  CInput,
  CInputCheckbox,
  CFormGroup,
  CLabel,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSwitch
} from "@coreui/react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DisciplinesModal from "./disciplines";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "./styles.css";

function CommunityUsersSelector({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [initialSelected, setInitialSelected] = useState([]);
  const [selected, setSelected] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [users, setUsers] = useState(0);
  const [search, setSearch] = useState("");
  const [onlyMembers, setOnlyMembers] = useState(false);
  const [roomDisciplines, setRoomDisciplines] = useState(null);
  const [modalDisciplines, setModalDisciplines] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const renderSizePerPageDropDown = () => (
    <CDropdown className="d-inline-flex">
      <CDropdownToggle color="outline-secondary" className="text-muted">
        {props.currSizePerPage}{" "}
      </CDropdownToggle>
      <CDropdownMenu>
        {props.sizePerPageList.map((n, idx) => {
          const isActive = n.text === props.currSizePerPage ? "active" : null;
          return (
            <CDropdownItem
              key={idx}
              className={isActive}
              onClick={() => props.changeSizePerPage(n.value)}
            >
              {n.text}
            </CDropdownItem>
          );
        })}
      </CDropdownMenu>
    </CDropdown>
  );

  const renderPaginationShowsTotal = (start, to, total) => (
    <span style={{ marginRight: "10px" }}>
      Item {start} até {to}, em um total de {total} itens
    </span>
  );

  useEffect(() => {
    axios
      .get(`${URL.api}community/room/singleView/${props.id}`, {
        headers: { Authorization: `Bearer ${props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const { room } = resp.data.data;
          const { room_user: roomUser } = resp.data.data;

          const disciplines = resp.data.data.room_discipline || [];
          const roomDiscipline =
            resp.data.data.room_user_discipline?.map(item => ({
              ...item,
              user_id:
                roomUser.find(user => user.id === item.room_user_id)?.user_id ||
                null
            })) || [];

          axios
            .post(
              `${URL.api}access/user/listUserFilter`,
              {
                group: room.group_id,
                region: room.region_id,
                school: room.school_id
              },
              {
                headers: { Authorization: `Bearer ${props.user.token}` }
              }
            )
            .then(resp => {
              if (resp.data.success) {
                const usersWithDiscipline = props.isRoom
                  ? resp.data.data
                  : resp.data.data.map(item => ({
                      ...item,
                      disciplines: roomDiscipline
                        .filter(discipline => discipline.user_id === item.id)
                        .map(discipline => discipline.room_discipline_id)
                    }));
                if (props.isModified) {
                  props.getUsers(usersWithDiscipline);
                }

                setUsers(usersWithDiscipline);
                setLoading(false);
                setRoomDisciplines(disciplines);
                setInitialSelected(
                  usersWithDiscipline.filter(user =>
                    roomUser.map(item => item.user_id).includes(user.id)
                  )
                );
                setSelected(
                  usersWithDiscipline.filter(user =>
                    roomUser.map(item => item.user_id).includes(user.id)
                  )
                );
                setAdmin(
                  usersWithDiscipline.filter(user =>
                    roomUser
                      .filter(item => item.administrator)
                      .map(item => item.user_id)
                      .includes(user.id)
                  )
                );

                props.getRoomDisciplines &&
                  props.getRoomDisciplines(disciplines);
                props.onChange &&
                  props.onChange(
                    props.isRoom
                      ? selected.map(item => ({
                          ...item,
                          administrator: !!admin.find(adm => adm.id === item.id)
                        }))
                      : selected
                  );
              }
            });
        }
      });
  }, []);

  const getOptions = () => ({
    defaultSortOrder: "asc",
    sortIndicator: true,
    paginationSize: 3,
    paginationPosition: "bottom",
    sizePerPage: 10,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      {
        text: "Todos",
        value: users?.length || 0
      }
    ],
    sizePerPageDropDown: renderSizePerPageDropDown,
    paginationShowsTotal: renderPaginationShowsTotal,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
    noDataText: "Nenhum utilizador foi encontrado para participar desta turma"
  });

  const toggleSelected = (user, isSelected) => {
    if (isSelected) {
      const newSelected = selected.filter(item => item !== user);
      setSelected(newSelected);
      props.onChange && props.onChange(newSelected);
    } else if (props.isRoom || props.isModified) {
      const newSelected = selected.concat(user);
      setSelected(newSelected);
      props.onChange &&
        props.onChange(
          newSelected.map(item => ({
            ...item,
            administrator: !!admin.find(adm => adm.id === item.id)
          }))
        );
    } else {
      setCurrentUser(user);
      if (!props.isModified) setModalDisciplines(true);
    }
  };

  const toggleAdmin = (user, selected) => {
    const newAdmin = selected
      ? admin.filter(item => item !== user)
      : admin.concat(user);
    setAdmin(newAdmin);
    props.onChange &&
      props.onChange(
        selected.map(item => ({
          ...item,
          administrator: !!newAdmin.find(adm => adm.id === item.id)
        }))
      );
  };

  const disciplineModalClose = selectedDisciplinesFromModal => {
    const userId = currentUser.id;

    if (selectedDisciplinesFromModal) {
      const newUsers = users.map(el =>
        el.id === userId
          ? { ...el, disciplines: selectedDisciplinesFromModal }
          : el
      );
      const newSelected = selected.concat(
        newUsers.find(el => el.id === userId)
      );
      setUsers(newUsers);
      setSelected(newSelected);
      props.onChange && props.onChange(newSelected);
    }

    setModalDisciplines(false);
    setCurrentUser(null);
  };

  // --------------------------------------------------------------------------
  // Função para extrair a série (ou as séries) que o utilizador pertence
  // --------------------------------------------------------------------------
  const getUserSeries = user => {
    if (
      !user.disciplines ||
      !Array.isArray(user.disciplines) ||
      user.disciplines.length === 0
    ) {
      return null;
    }

    let seriesNames = [];

    user.disciplines.forEach(d => {
      if (typeof d === "object" && d !== null) {
        if (d.serie_name) seriesNames.push(d.serie_name);
        else if (d.serie_id) seriesNames.push(`Série ${d.serie_id}`);
      } else if (roomDisciplines) {
        const roomDisc = roomDisciplines.find(rd => rd.id === d);
        if (roomDisc && roomDisc.serie_name) {
          seriesNames.push(roomDisc.serie_name);
        }
      }
    });

    seriesNames = [...new Set(seriesNames)];
    return seriesNames.length > 0 ? seriesNames.join(" / ") : null;
  };

  const cellButton = (cell, row, enumObject, rowIndex) => {
    const isSelected = selected.indexOf(row) !== -1;

    return (
      <div className="actionBtns">
        <button
          type="button"
          className={`btn btn-${isSelected ? "danger" : "primary"}`}
          onClick={() => toggleSelected(row, isSelected)}
        >
          {isSelected ? "Remover" : "Adicionar"}
        </button>
      </div>
    );
  };

  const cellAdministratorButton = (cell, row, enumObject, rowIndex) => {
    const isAdmin = admin.indexOf(row) !== -1;

    return (
      <div className="d-flex align-items-center">
        <CSwitch
          shape="pill"
          size="sm"
          color="primary"
          className="mr-3"
          checked={isAdmin}
          onChange={() => toggleAdmin(row, isAdmin)}
        />
        {isAdmin ? "Administrador" : "Membro"}
      </div>
    );
  };

  // --------------------------------------------------------------------------
  // Lógica para contar estudantes e professores nos selecionados
  // --------------------------------------------------------------------------
  const countStudents = selected.filter(
    user => user.role_name && user.role_name.toLowerCase().includes("estudante")
  ).length;

  const countTeachers = selected.filter(
    user => user.role_name && user.role_name.toLowerCase().includes("professor")
  ).length;

  return (
    <>
      {modalDisciplines && (
        <DisciplinesModal
          disciplines={roomDisciplines}
          onClose={e => disciplineModalClose(e)}
        />
      )}
      <CRow className="d-flex align-items-center px-3 py-3">
        {/* Coluna da Esquerda: Checkbox + Contagens logo abaixo */}
        <CCol sm="8">
          {!props.onlyAdd && (
            <CFormGroup variant="checkbox" className="checkbox mb-2">
              <CInputCheckbox
                id="checkbox"
                name="checkbox"
                checked={onlyMembers}
                onChange={e => setOnlyMembers(e.target.checked)}
              />
              <CLabel
                variant="checkbox"
                className="form-check-label"
                htmlFor="checkbox"
              >
                Mostrar apenas selecionados
              </CLabel>
            </CFormGroup>
          )}

          <div className="mt-1">
            <span
              style={{
                fontWeight: "bold"
              }}
            >
              {countStudents} estudante(s) e {countTeachers} professor(es)
              selecionado(s)
            </span>
          </div>
        </CCol>

        {/* Coluna da Direita: Campo de Busca */}
        <CCol sm="4">
          <CInput
            type="text"
            placeholder="Procurar"
            style={{ maxWidth: "200px" }}
            className="float-right"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </CCol>
      </CRow>

      {loading ? (
        <div className="py-3 w-100 d-flex align-items-center justify-content-center">
          <Loading />
        </div>
      ) : (
        <BootstrapTable
          data={users.filter(
            user =>
              (user.name.toLowerCase().includes(search.toLowerCase()) ||
                user.role_name.toLowerCase().includes(search.toLowerCase())) &&
              (!onlyMembers || selected.indexOf(user) !== -1) &&
              (!props.onlyAdd || initialSelected.indexOf(user) === -1)
          )}
          options={() => getOptions()}
          version="4"
          data-pagination-h-align="top"
          striped
          pagination
          noDataIndication="Nenhum utilizador foi encontrado para participar desta turma"
        >
          <TableHeaderColumn
            isKey
            className="d-none"
            dataField="id"
            tdStyle={{ verticalAlign: "middle" }}
            dataFormat={(_, row) => {
              const isSelected = selected.indexOf(row) !== -1;
              const userSeries = isSelected ? getUserSeries(row) : null;

              return (
                <div className="d-flex align-items-center justify-content-start">
                  <img
                    className="c-avatar-img mr-3"
                    style={{ height: "2rem", width: "2rem" }}
                    src={
                      row.photo
                        ? URL.img + row.photo
                        : `${URL.img}uploads/users/profileEmpty.jpg`
                    }
                    alt=""
                  />
                  <div>
                    <div style={{ fontWeight: "500" }}>{row.name}</div>
                    <div
                      className="text-muted d-flex align-items-center"
                      style={{ fontSize: "0.85rem" }}
                    >
                      {row.role_name}
                      {isSelected && userSeries && (
                        <span
                          className="badge badge-info ml-2 px-2 py-1"
                          style={{ fontWeight: "500", borderRadius: "10px" }}
                        >
                          {userSeries}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            }}
          >
            Nome
          </TableHeaderColumn>
          {props.isRoom && (
            <TableHeaderColumn
              dataField="administrator"
              dataFormat={cellAdministratorButton}
              className="d-none"
              tdStyle={{ verticalAlign: "middle" }}
            >
              Administrador
            </TableHeaderColumn>
          )}
          <TableHeaderColumn
            dataField="button"
            dataFormat={cellButton}
            className="d-none"
            tdStyle={{ verticalAlign: "middle" }}
          >
            Ação
          </TableHeaderColumn>
        </BootstrapTable>
      )}
    </>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityUsersSelector);
